import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export default function ScrollToTop() {
  const [visible, setVisible] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const pct = docHeight > 0 ? (scrollY / docHeight) * 100 : 0;
      setProgress(Math.min(100, Math.max(0, pct)));
      setVisible(scrollY > 500);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const circumference = 2 * Math.PI * 45;
  const dashOffset = circumference - (circumference * progress) / 100;

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, scale: 0.6, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.6, y: 20 }}
          transition={{ type: 'spring', stiffness: 300, damping: 20 }}
          className="fixed bottom-5 right-5 md:bottom-20 md:right-9 z-50"
        >
          {/* Progress ring container */}
          <div className="relative w-14 h-14 md:w-16 md:h-16">
            {/* SVG progress ring */}
            <svg
              viewBox="0 0 100 100"
              className="absolute inset-0 w-full h-full -rotate-90"
            >
              {/* Track circle */}
              <circle
                cx="50"
                cy="50"
                r="45"
                fill="none"
                stroke="#e5efbe"
                strokeWidth="4"
                className="opacity-60"
              />
              {/* Progress circle */}
              <circle
                cx="50"
                cy="50"
                r="45"
                fill="none"
                stroke="#95c302"
                strokeWidth="4"
                strokeLinecap="round"
                strokeDasharray={circumference}
                strokeDashoffset={dashOffset}
                className="transition-all duration-150 ease-out"
              />
            </svg>

            {/* Button */}
            <button
              onClick={scrollToTop}
              className="absolute inset-[3px] md:inset-[4px] flex items-center justify-center bg-primary-500 text-white rounded-full shadow-lg shadow-primary-500/25 hover:shadow-xl hover:shadow-primary-500/30 hover:bg-primary-600 hover:-translate-y-0.5 transition-all duration-300 cursor-pointer"
              aria-label="Scroll to top"
            >
              <i className="ri-arrow-up-line text-lg md:text-xl"></i>
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}